const RAKUTEN_COUPON_HOST = 'coupon.rakuten.co.jp';

function parseSafeHttpsUrl(value: string | null | undefined): URL | null {
  try {
    const url = new URL(String(value ?? '').trim());
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    return url;
  } catch {
    return null;
  }
}

export function safeRakutenCouponUrl(value: string | null | undefined): string | null {
  const url = parseSafeHttpsUrl(value);
  if (!url || url.hostname !== RAKUTEN_COUPON_HOST || url.port) return null;
  return url.toString();
}

export function safeImageUrl(value: string | null | undefined): string | null {
  return parseSafeHttpsUrl(value)?.toString() ?? null;
}
